module.exports = "<div class=\"row\">\n\t<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n\t\t<div class=\"footer\"></div>\n\t</div>\n</div>"